// RESIZE PAGE
function resizePage() {
  var windowWidth = $(window).width();
  var windowHeight = $(window).height();

  var ratio = 13 / 8;
  if (windowWidth / windowHeight >= ratio) {
    // height dependent because width is larger than ratio's width
    var newWidth = windowHeight * ratio;
    $(".interface-container-yash").css("width", newWidth);
    $(".interface-container-yash").css("height", windowHeight);

    $(".interface-test-yash").css("height", "82vh");
    $(".interface-bottom-bar-yash").css("height", "10vh");
  } else {
    // width dependent because height is larger than ratio's height
    var newHeight = windowWidth / ratio;
    $(".interface-container-yash").css("height", newHeight);
    $(".interface-container-yash").css("width", windowWidth);
    $(".interface-test-yash").css("height", newHeight * 0.8);
    $(".interface-bottom-bar-yash").css("height", newHeight * 0.1);
  }

  // setting bottom bubble heights
  ratio = 18 / 24;
  var bottomBubbleWidth = $(".interface-bottom-bubble-yash").width();
  $(".interface-bottom-bubble-yash").css("height", bottomBubbleWidth * ratio);
  $(".interface-bottom-bubble-wrap-yash").css(
    "fontSize",
    bottomBubbleWidth * ratio + 5
  );

  // setting the answer choice bubble heights
  ratio = 29.5 / 41;
  var bubbleWidth = $(
    "#interface-questions-circle-" + currentQuestion.number + "-first-yash"
  ).width();
  $(".interface-questions-circle-yash").css("height", bubbleWidth * ratio);
  $(".interface-questions-circle-yash").css(
    "fontSize",
    bubbleWidth * ratio - 6
  );
  $(".interface-elimination-circle-yash").css("height", bubbleWidth * ratio);
  $(".interface-elimination-circle-yash").css(
    "fontSize",
    bubbleWidth * ratio - 6
  );

  // resize bottom buttons
  ratio = 50 / 70;
  var arrowWidth = $(".interface-move-button-yash").width();
  $(".interface-move-button-yash").css("height", arrowWidth * ratio);

  // set height to width of flag
  var flagWidth = $(
    "#flag-button-" + currentQuestion.number + "-first-yash"
  ).width();
  $(".flag-button-yash").css("height", flagWidth);

  ratio = 14 / 21;
  var bottomBubbleWidth = $(".interface-bottom-bubble-yash").width();
  $(".interface-bottom-bubble-yash").css("height", ratio * bottomBubbleWidth);

  // resizing covers for images
  var questionWidth = $(
    "#interface-questions-container-holder-" +
      currentQuestion.number +
      "-yash"
  )
    .find(".interface-cover-yash img")
    .width();
  var numQuestions = $(".interface-bottom-bubble-yash").length;
  for (var i = 1; i <= numQuestions; i++) {
    var questionCovers = $(
      "#interface-questions-container-holder-" + i + "-yash"
    ).find(".interface-cover-yash img");
    var imgRatio =
      questionCovers[1].naturalHeight / questionCovers[1].naturalWidth;
    $(questionCovers[0]).height(Math.ceil(questionWidth * imgRatio));
  }

  var setupWidth = $(
    "#interface-setup-container-" + currentQuestion.number + "-yash"
  )
    .find(".interface-cover-yash img")
    .width();
  for (var i = 1; i <= $(".interface-setup-container-yash").length; i++) {
    var setupCovers = $("#interface-setup-container-" + i + "-yash").find(
      ".interface-cover-yash img"
    );
    var imgRatio = setupCovers[1].naturalHeight / setupCovers[1].naturalWidth;
    var imgHeight = setupWidth * imgRatio;
    $(setupCovers[0]).height(imgHeight);
  }
}

//TIMER
jquery_timer();
var currentQuestion;
var GameTimer;

// Helper function to get currentQuestion (checks window if module variable is not set)
function getCurrentQuestion() {
  if (typeof currentQuestion !== 'undefined' && currentQuestion) {
    return currentQuestion;
  }
  if (typeof window !== 'undefined' && typeof window.currentQuestion !== 'undefined') {
    // Sync module variable with window
    currentQuestion = window.currentQuestion;
    return currentQuestion;
  }
  return null;
}

//MOUSE EVENT
function pressKey(event) {
  switch (event.keyCode) {
    case 37: //left key
      backOne();
      break;
    case 39: //right key
      forwardOne();
      break;
    case 65:
    case 97: //A
      var questionChoice = $(".interface-questions-container-holder-yash")
        .eq(currentQuestion.number - 1)
        .find(".interface-questions-circle-yash")
        .eq(0);
      questionChoice.click();
      break;
    case 66:
    case 98: //B
      var questionChoice = $(".interface-questions-container-holder-yash")
        .eq(currentQuestion.number - 1)
        .find(".interface-questions-circle-yash")
        .eq(1);
      questionChoice.click();
      break;
    case 67:
    case 99: //C
      var questionChoice = $(".interface-questions-container-holder-yash")
        .eq(currentQuestion.number - 1)
        .find(".interface-questions-circle-yash")
        .eq(2);
      questionChoice.click();
      break;
    case 68:
    case 100: //D
      var questionChoice = $(".interface-questions-container-holder-yash")
        .eq(currentQuestion.number - 1)
        .find(".interface-questions-circle-yash")
        .eq(3);
      questionChoice.click();
      break;
    case 69:
    case 101: //E
      var questionChoice = $(".interface-questions-container-holder-yash")
        .eq(currentQuestion.number - 1)
        .find(".interface-questions-circle-yash")
        .eq(4);
      questionChoice.click();
      break;
    case 102:
    case 70: //F
      var flagElement = $(".interface-questions-container-holder-yash")
        .eq(currentQuestion.number - 1)
        .find(".flag-button-yash")
        .eq(1);
      flagElement.click();
      break;
  }
}

//MODAL
function dismissWarningModal() {
  $("#interface-modal-warning-container-yash").remove();
}
function dismissTimeUpModal() {
  $("#interface-modal-timeup-container-yash").remove();
}

function digitalSectionEventHandlers(imageData = undefined) {
  $(".interface-elimination-circle-yash").click(function() {
  var questionNumber = $(this).attr("data-qnumber");
  var letterNumber = $(this).attr("data-letter");

  if ($(this).attr("data-clicked") == 0) {
    $(this)
      .find(".interface-line-yash")
      .css("display", "none");

    var question = $(
      "#interface-questions-container-holder-" + questionNumber + "-yash"
    )
      .find(".interface-questions-circle-yash")
      .filter(function() {
        return $(this).attr("data-letter") == letterNumber;
      });
    question.find(".interface-line-yash").css("display", "block");

    $(this).attr("data-clicked", 1);

      //reset question
    unclickAnswer(question);
  } else {
    $(this)
      .find(".interface-line-yash")
      .css("display", "block");
    $(this).attr("data-clicked", 0);

    var question = $(
      "#interface-questions-container-holder-" + questionNumber + "-yash"
    )
      .find(".interface-questions-circle-yash")
      .filter(function() {
        return $(this).attr("data-letter") == letterNumber;
      });
    question.find(".interface-line-yash").css("display", "none");
    }
  });

  $(".flag-button-yash").click(function() {
    if ($(this).hasClass("fake-flag-yash")) return;

    if ($(this).hasClass("question-clicked-flag-yash")) {
      var index = $(this).attr("data-qnumber");
      $(this).removeClass("question-clicked-flag-yash");
      $("#interface-bottom-current-bubble-" + index + "-yash")
        .removeClass("bottom-interface-flag-unclicked-yash")
        .removeClass("bottom-interface-flag-clicked-yash");

      if (currentQuestion.number == index) {
        $("#interface-bottom-current-bubble-" + index + "-yash").addClass(
          "interface-black-yash"
        );
      }

      var flagCheck = $("#flagged" + index + "-yash");
      flagCheck.val("0");
    } else {
      var index = $(this).attr("data-qnumber");
      $(this).addClass("question-clicked-flag-yash");
      $("#interface-bottom-current-bubble-" + index + "-yash")
        .addClass("bottom-interface-flag-unclicked-yash")
        .addClass("bottom-interface-flag-clicked-yash");
      $("#interface-bottom-current-bubble-" + index + "-yash").removeClass(
        "interface-black-yash"
      );

      var flagCheck = $("#flagged" + index + "-yash");
      flagCheck.val("1");
    }
  });

  $(".interface-bottom-bubble-wrap-yash").click(function() {
      $(".interface-bottom-bubble-wrap-yash").css("fontWeight", "normal");
      $(this).css("fontWeight", 700);

      var i = $(this).attr("data-qnumber");

      $(".interface-questions-container-holder-yash").css("display", "none");
      $("#interface-questions-container-holder-" + i + "-yash").css(
        "display",
        "block"
      );
      $(".interface-bottom-current-bubble-yash").removeClass(
        "interface-black-yash"
      );

      var currentBubble = $("#interface-bottom-current-bubble-" + i + "-yash");
      currentBubble.addClass("interface-black-yash");

      //change the current setup
      var currGame = $(this).attr("data-setup-number");
      $(".interface-setup-container-yash").css("display", "none");
      $("#interface-setup-container-" + currGame + "-yash").css(
        "display",
        "block"
      );

      //when the user clicks a setup, we must update the total amount of time that
      //has been spent on that particular setup
      if (currentQuestion.startTime != 0) {
        var timeClicked = new Date().getTime();
        var timeToAdd = timeClicked - currentQuestion.startTime; // the amount of time spent on this setup before the user clicked it this time
        var totalTimeSpent =
          timeToAdd +
          Number($("#time-spent-" + currentQuestion.number + "-yash").val());
        $("#time-spent-" + currentQuestion.number + "-yash").val(totalTimeSpent);
      }

      currentQuestion.change(i);
      currentQuestion.startTime = timeClicked;

      //flags
      i--;
      if (
        currentBubble.hasClass("bottom-interface-flag-unclicked-yash") ||
        currentBubble.hasClass("bottom-interface-flag-clicked-yash")
      ) {
        $(".interface-bottom-current-bubble-yash").removeClass(
          "bottom-interface-flag-clicked-yash"
        );
        currentBubble
          .removeClass("interface-black-yash")
          .addClass(
            "bottom-interface-flag-unclicked-yash bottom-interface-flag-clicked-yash"
          );
      } else {
        $(".interface-bottom-current-bubble-yash").removeClass(
          "bottom-interface-flag-clicked-yash"
        );
      }
      // highlighter
      setTimeout(function() {
        if (imageData !== undefined)  {
          var setupImageId = $("#interface-setup-container-" + currGame + "-yash").find(".interface-highlight-container-yash").get(0).id.replace("-highlight-yash", "");
          var questionImageId = $("#interface-questions-container-holder-" + (i+1) + "-yash").find(".interface-highlight-container-yash").get(0).id.replace("-highlight-yash", "");
          if (i !== 0) { // first question
            loadHighlightForOneImage(setupImageId, imageData);
            loadHighlightForOneImage(questionImageId, imageData);
          }

        }
      }, 200);
  });

  $(".interface-questions-circle-yash").click(function() {
    if ($(this).hasClass("interface-filled-green-yash")) {
      unclickAnswer(this);
    } else {
      clickAnswer(this);
    }

    $(this)
      .find(".interface-line-yash")
      .css("display", "none");
  });

  $("#interface-form-yash").submit(function(event) {
    // Note: This function will not wait for asynchronous calls to complete
    event.preventDefault();
    setupSubmitForm();
    $(this).unbind('submit').submit(); // unbind this event handler so that we can actually submit the form
  })
}

function startTest() {
  $(".interface-pre-start-cover-yash").css("display", "none");
  $("#interface-questions-container-holder-1-yash").css("filter", "none");
  $("#interface-start-yash").remove();
  document.addEventListener("keydown", pressKey);
  $(".interface-timer-yash").click(showTime);
  $(".interface-test-yash").css("filter", "none");
  // Get currentQuestion (handles module vs global scope)
  const questionRef = getCurrentQuestion();
  if (!questionRef) {
    console.error('[startTest] currentQuestion is not initialized. Make sure lsat-section controller has initialized.');
    return;
  }
  GameTimer = new GameTimerYash(questionRef);
  $(".interface-timer-yash").css("cursor", "pointer");

  //alert
  // window.onbeforeunload = function() {
  //   alert(
  //     "Are you sure you want to leave this section? Your answers have not been saved."
  //   );
  // };
}

// Ensure functions and variables are available on window for Stimulus controllers
if (typeof window !== 'undefined') {
  window.startTest = startTest;
  window.pressKey = pressKey;
  window.showTime = showTime;
  window.digitalSectionEventHandlers = digitalSectionEventHandlers;
  window.testDigitalSection = testDigitalSection;
  // currentQuestion and GameTimer are already global variables, but ensure they're accessible
  if (typeof currentQuestion !== 'undefined') {
    window.currentQuestion = currentQuestion;
  }
  if (typeof GameTimer !== 'undefined') {
    window.GameTimer = GameTimer;
  }
}

function clickAnswer(bubble) {
  var index = $(bubble).attr("data-qnumber");
  var formAnswer = $("#question" + index + "-yash");
  index--;

  $(bubble)
    .siblings()
    .removeClass("interface-filled-green-yash");
  $(bubble).addClass("interface-filled-green-yash");
  $(".interface-bottom-bubble-yash:eq(" + index + ")").addClass(
    "interface-black-yash"
  );

  $(bubble)
    .find(".interface-line-yash")
    .css("display", "none");

  //form
  formAnswer.val($(bubble).attr("data-letter"));

  //elimination
  var setupNumber = $(bubble).attr("data-qnumber");
  var letterNumber = $(bubble).attr("data-letter");
  var eliminator = $(
    "#interface-questions-container-holder-" + setupNumber + "-yash"
  )
    .find(".interface-elimination-circle-yash")
    .filter(function() {
      return $(this).attr("data-letter") == letterNumber;
    });
  eliminator.find(".interface-line-yash").css("display", "block");
  eliminator.attr("data-clicked", 0);
}

function unclickAnswer(bubble) {
  var index = $(bubble).attr("data-qnumber");
  var formAnswer = $("#question" + index + "-yash");
  index--;

  if ($(bubble).hasClass("interface-filled-green-yash")) {
    $(bubble).removeClass("interface-filled-green-yash");
    $(bubble)
      .siblings()
      .removeClass("interface-filled-green-yash");
    $(".interface-bottom-bubble-yash:eq(" + index + ")").removeClass(
      "interface-black-yash"
    );

    //form
    formAnswer.val("");
  }
}

function trySubmitForm() {
  // window.onbeforeunload = null;
  if (window.confirm("Are you sure you want to submit this section?")) {
    $(".interface-move-button-yash").remove();
    $("#submit-visual-yash").html("Submitting...");
    $("#submit-visual-yash").off("click");
    $("#submit-visual-yash").css("width", "auto");
    $("#submit-yash").click();
  }
}

function setupSubmitForm() {
  // get last time
  var timeClicked = new Date().getTime();
  var timeToAdd = timeClicked - currentQuestion.startTime; // the amount of time spent on this setup before the user clicked it this time
  //add the time spent on the current question to its time-spent value before submitting form
  var totalTimeSpent =
    timeToAdd +
    Number($("#time-spent-" + currentQuestion.number + "-yash").val());
  $("#time-spent-" + currentQuestion.number + "-yash").val(totalTimeSpent);

  //convert all time-spent vals from milliseconds to seconds
  var i;
  var numQuestions = $(".interface-bottom-bubble-yash").length;
  for (i = 1; i <= numQuestions; i++) {
    var integerVersion = parseInt(
      $("#time-spent-" + i + "-yash").val() / 1000
    );
    $("#time-spent-" + i + "-yash").val(integerVersion);
  }

  GameTimer.stopTimer();
}

function backOne() {
  var current = currentQuestion.number;
  if (current == 1) {
    return;
  }
  current--;

  var clickThisBubble = $(
    "#interface-bottom-current-bubble-" + current + "-yash"
  ).parent();
  clickThisBubble.click();
}

function forwardOne() {
  var current = currentQuestion.number;
  var lastQuestionNumber = $(".interface-bottom-bubble-yash").length;
  if (current == lastQuestionNumber) {
    return;
  }
  current++;

  var clickThisBubble = $(
    "#interface-bottom-current-bubble-" + current + "-yash"
  ).parent();
  clickThisBubble.click();
}

function showTime() {
  //if time is showing and the user clicks the Time Remaining bar, hide the time
  if ($(".interface-timer-yash").attr("data-show") == 1) {
    $("#stopwatch-yash").addClass("interface-timer-hide-yash");
    $(".interface-progress-bar-yash").addClass("interface-timer-hide-yash");
    $(".interface-timer-yash").attr("data-show", 0);
  } else {
    $("#stopwatch-yash").removeClass("interface-timer-hide-yash");
    $(".interface-progress-bar-yash").removeClass(
      "interface-timer-hide-yash"
    );
    $(".interface-timer-yash").attr("data-show", 1);
  }
}

// Test Function
function testDigitalSection() {
  $(".interface-word-yash").addClass("interface-perm-pink-yash");
  $(".interface-gap-yash").addClass("interface-perm-orange-yash");
}